import { useEffect } from "react";
import { motion } from "framer-motion";

function setMeta(name, content, attr = "name") {
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

const WHATSAPP_NUMBER = "905372153407";
const WHATSAPP_MESSAGE = encodeURIComponent(
  "Merhaba, randevu almak istiyorum. Aşağıdaki bilgileri paylaşıyorum:\n\n" +
    "• Ad Soyad:\n" +
    "• Tercih ettiğiniz tarih / saat:\n" +
    "• Seans türü (online / yüz yüze):\n" +
    "• Kısaca görüşmek istediğiniz konu:\n\n" +
    "Teşekkürler."
);
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;
const PHONE_URL = "tel:+905372153407";

export default function RandevuAl() {
  useEffect(() => {
    const url = "https://aysunseremet.com/randevu-al";
    document.title =
      "Randevu Al — Antalya Psikolog Aysun Şeremet | WhatsApp ile İletişim";
    setMeta(
      "description",
      "Uzm. Klinik Psikolog Aysun Şeremet ile randevu almak için WhatsApp üzerinden iletişime geçin. Online veya yüz yüze seans için hızlı randevu."
    );
    setMeta(
      "og:title",
      "Randevu Al — Antalya Psikolog Aysun Şeremet",
      "property"
    );
    setMeta(
      "og:description",
      "WhatsApp üzerinden kolayca randevu alın. Online veya yüz yüze seans imkanı.",
      "property"
    );
    setMeta("og:url", url, "property");
    let c = document.querySelector('link[rel="canonical"]');
    if (!c) {
      c = document.createElement("link");
      c.rel = "canonical";
      document.head.appendChild(c);
    }
    c.href = url;
  }, []);

  const handleWhatsAppClick = () => {
    // Google Ads Conversion Tracking
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: "AW-402122547/9FmOCP2lt54cELPO378B",
        value: 1.0,
        currency: "TRY",
      });
      window.gtag("event", "click_whatsapp_randevu", {
        event_category: "conversion",
        event_label: "randevu_whatsapp",
        value: 1,
      });
    }
  };

  const handlePhoneClick = () => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "click_phone_randevu", {
        event_category: "contact",
        event_label: "randevu_phone",
        value: 1,
      });
    }
  };

  return (
    <section className="min-h-[80vh] bg-white px-4 py-16 sm:py-20">
      <div className="mx-auto max-w-2xl">
        {/* Hero */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-pink-600">
            Randevu
          </p>
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            WhatsApp Üzerinden Randevu Alın
          </h1>
          <div className="mx-auto mt-5 h-px w-16 bg-pink-400" />
          <p className="mx-auto mt-6 max-w-lg text-base leading-relaxed text-gray-600">
            Uzm. Klinik Psikolog <span className="font-medium text-gray-900">Aysun Şeremet</span> ile randevu almak için WhatsApp üzerinden hızlıca iletişime geçebilirsiniz.
            24 saat içinde size dönüş yapılacaktır.
          </p>
        </motion.div>

        {/* WhatsApp Ana CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="mt-12"
        >
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleWhatsAppClick}
            className="group flex w-full items-center justify-center gap-3 rounded-2xl bg-gradient-to-r from-emerald-500 to-green-600 px-6 py-5 text-base font-semibold text-white shadow-lg shadow-emerald-500/30 transition hover:shadow-xl hover:shadow-emerald-500/40 hover:scale-[1.01]"
          >
            <svg
              className="h-7 w-7"
              fill="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
            </svg>
            <span>WhatsApp ile Randevu Al</span>
            <span
              className="ml-1 transition-transform group-hover:translate-x-1"
              aria-hidden="true"
            >
              →
            </span>
          </a>
          <p className="mt-3 text-center text-xs text-gray-500">
            WhatsApp uygulaması açılacak, mesaj hazır olarak gelir.
          </p>
        </motion.div>

        {/* Telefon CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="mt-4"
        >
          <a
            href={PHONE_URL}
            onClick={handlePhoneClick}
            className="flex w-full items-center justify-center gap-3 rounded-2xl bg-white px-6 py-4 text-base font-semibold text-gray-900 ring-1 ring-gray-200 transition hover:ring-pink-300 hover:shadow-sm"
          >
            <svg
              className="h-5 w-5 text-pink-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                d="M3 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H5.5l.5 1a11 11 0 005 5l1 .5V14a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-1C10 18 6 14 6 6V5z"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>0537 215 34 07</span>
          </a>
        </motion.div>

        {/* Bilgilendirme */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="mt-10 rounded-2xl bg-pink-50 p-6 ring-1 ring-pink-100"
        >
          <h2 className="text-sm font-semibold uppercase tracking-wider text-pink-700">
            Randevu süreci
          </h2>
          <ul className="mt-3 space-y-2.5 text-sm text-gray-700">
            <li className="flex items-start gap-3">
              <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-pink-400" />
              <span>
                WhatsApp veya telefon yoluyla iletişime geçin, tercih ettiğiniz
                tarih ve saati paylaşın.
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-pink-400" />
              <span>
                Online veya yüz yüze seans tercihinizi belirtin (Muratpaşa
                kliniği veya online).
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-pink-400" />
              <span>
                24 saat içinde size dönüş yapılarak randevunuz planlanır.
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-pink-400" />
              <span>
                Seanslar 50 dakika sürer, hafta sonu uygun saatler de
                bulunmaktadır.
              </span>
            </li>
          </ul>
        </motion.div>

        {/* Çalışma saatleri */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="mt-6 text-center text-sm text-gray-500"
        >
          <p>
            <span className="font-medium text-gray-700">Çalışma Saatleri:</span>{" "}
            Pazartesi–Cumartesi &nbsp;|&nbsp; 10:00 – 19:00
          </p>
        </motion.div>
      </div>
    </section>
  );
}
